import React, { useState, useEffect, useMemo, useCallback } from "react";
import styles from "../assets/css/UserList.module.css";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { postData1, deleteContact } from "../../services";
import { Pagination, DownloadToExcel } from "../Common";

export const ContactList = () => {
  const [requestlistData, setRequestListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "created_date",
    direction: "desc",
  });

  const navigate = useNavigate();

  // OPTIMIZATION 1: useMemo for derived data so it doesn't recalculate on every render
  const downloadData = useMemo(() => {
    return requestlistData.map((d) => ({
      id: d?.id,
      date: d?.created_date ? new Date(d.created_date).toLocaleDateString() : "",
      name: d?.name || "",
      email: d?.email || "",
      phone: d?.contact_no || "",
      // detail: d?.message || "",
      detail: d?.others?.product_name || "",
       url: d?.others?.product_url || "",
    }));
  }, [requestlistData]);

  // OPTIMIZATION 2: useMemo for sorting to prevent unnecessary calculations
  const requestListDataSorted = useMemo(() => {
    return [...requestlistData].sort((a, b) => {
      const { key, direction } = sortConfig;
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [requestlistData, sortConfig]);

  // OPTIMIZATION 3: useCallback to prevent recreation of functions on every render
  const updatePage = useCallback((e) => {
    let name = e.currentTarget.name;
    setPrevPage(currPage); // We can just set this once

    if (name === "prev") {
      setCurrPage((prev) => (prev === 1 ? 1 : prev - 1));
    } else if (name === "next") {
      setCurrPage((prev) => (prev === paging?.total_pages ? prev : prev + 1));
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currPage, paging?.total_pages]);

  const handleSort = useCallback((column) => {
    setSortConfig((prevConfig) => {
      let direction = "asc";
      if (prevConfig.key === column && prevConfig.direction === "asc") {
        direction = "desc";
      }
      return { key: column, direction };
    });
  }, []);

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) return null;
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const fetchData = useCallback(async () => {
    setLoader(true);

    try {
      const config = { _page: currPage, _limit: perPage };
      const res = await postData1("contact/lists/", config, true, true);

      setRequestListData(res?.data?.data || []);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }, [currPage, perPage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this contact?")) return;

    try {
      console.log("Deleting:", id);

      const res = await deleteContact(id);
      console.log("Delete Response:", res);

      await fetchData();

      console.log("After fetch:", requestlistData);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>CONTACTS MANAGEMENT</h1>
        <div className="w-6 h-6">
          {/* <DownloadToExcel data={downloadData} filename={`contacts-page-${currPage}`} /> */}
        </div>
      </div>

      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSort("id")} style={{ cursor: "pointer" }}>
            ID {getSortIcon("id")}
          </span>
          <span onClick={() => handleSort("created_date")} style={{ cursor: "pointer" }}>
            Date {getSortIcon("created_date")}
          </span>
          <span onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
            Name {getSortIcon("name")}
          </span>
          <span onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
            Email {getSortIcon("email")}
          </span>
          <span onClick={() => handleSort("contact_no")} style={{ cursor: "pointer" }}>
            Phone {getSortIcon("contact_no")}
          </span>
          <span>DETAIL</span>
          <span>ACTIONS</span>
        </div>

        {!loader && requestListDataSorted.length === 0 && (
          <div style={{ textAlign: "center", padding: "20px" }}>No contacts found.</div>
        )}

        {requestListDataSorted.map((data) => (
          <div className={styles.itemData} key={data.id}>
            <span>{data?.id}</span>
            <span>{data?.created_date ? new Date(data.created_date).toLocaleDateString() : "-"}</span>
            <span>{data?.name}</span>
            <span>{data?.email}</span>
            <span>{data?.contact_no}</span>
            <span>{data?.others?.product_name || "-"}</span>
            <div style={{ display: "flex", gap: "10px" }}>
              <span
                onClick={() => navigate("/admin/contactlist/view/", { state: data })}
                style={{ cursor: "pointer", color: "blue" }}
              >
                View
              </span>
              {/* <span
                onClick={() => handleDelete(data.id)}
                style={{ cursor: "pointer", color: "red" }}
              >
                Delete
              </span> */}
            </div>
          </div>
        ))}
      </div>

      {paging?.total_pages > 1 && (
        <Pagination
          total={paging?.total}
          perPage={perPage}
          currPage={currPage}
          setCurrPage={setCurrPage}
          prevPage={prevPage}
          tPage={paging?.total_pages}
          updatePage={updatePage}
          setPerPage={setPerPage}
        />
      )}

      {loader && <Loader />}
    </section>
  );
};



